import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { DeviceLatestCommandStatusSettings } from '../models/device-latest-command-status-settings.model';
import { AbstractDeviceCommandService } from '../services/abstract-device-command.service';

export const DEVICE_LATEST_COMMAND_STATUS_SETTINGS = new InjectionToken<DeviceLatestCommandStatusSettings>('DEVICE_LATEST_COMMAND_STATUS_SETTINGS');

const getDeviceCommandProviders = (settings: DeviceLatestCommandStatusSettings) => [
  { provide: DEVICE_LATEST_COMMAND_STATUS_SETTINGS, useValue: settings },
  { provide: AbstractDeviceCommandService, useClass: settings.deviceCommandService }
];

// Used for lazy loading in a specific module
export function provideDeviceCommandSettings(settings: DeviceLatestCommandStatusSettings): EnvironmentProviders {
  return makeEnvironmentProviders([...getDeviceCommandProviders(settings)]);
}
